import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/arrow-up-right-from-square.svg'

@Component({
  tag: 'cr-icon-arrow-up-right-from-square',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconArrowUpRightFromSquare {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
